import React, { useEffect, useState } from "react";
import { Button, Input, Select, DatePicker, Row, Col, Form, Card, Tabs } from "antd";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import JobRegisterTab from "./JobRegisterTab";
import WorkOrderTab from "./WorkOrderTab";
import WorkHistoryTab from "./WorkOrderHistoryTab";

const { TextArea } = Input;

const AddMachinery = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const functionName = location.state?.functionName || "";
    const [form] = Form.useForm();
    const [activeTab, setActiveTab] = useState(
        localStorage.getItem("activeTab") || "1"
    );
    const [loader, setLoader] = useState(false);
    const [machineryList, setMachineryList] = useState([]);
    const editData = location.state?.editData;
    const viewOnly = location.state?.viewOnly;
    const [machineryData, setMachineryData] = useState(editData);
    const [hasMachineryDetails, setHasMachineryDetails] = useState(Boolean(editData));
    const [machineryid, setmachineryId] = useState("")
    const userData = JSON.parse(localStorage.getItem("user_data"));
    const shipId = userData?.data?.ship_details?.ship_id;

    const hasData = (data) => {
        if (!data) return false;
        if (Array.isArray(data)) return data.length > 0;
        if (typeof data === "object") return Object.keys(data).length > 0;
        return true;
    };

    useEffect(() => {
        if (shipId) {
            form.setFieldsValue({ ship_id: shipId });
            fetchMachineryList(shipId);
            fetchMachineryDetails(shipId);
        } else {
            setMachineryData(null);
            setmachineryId("");
            setHasMachineryDetails(false);
            form.resetFields();
            form.setFieldsValue({ machinery_name: functionName });
        }
    }, [shipId]);

    useEffect(() => {
        if (functionName) {
            form.setFieldsValue({ machinery_name: functionName });
        }
    }, [functionName, form]);


    const fetchMachineryList = async (shipId) => {
        if (!shipId) {
            setMachineryList([]);
            return;
        }
        try {
            const FORM_DATA = new FormData();
            FORM_DATA.append("ship_id", shipId);

            const res = await post(ApiURL.staff_ship_machinery_list, FORM_DATA);

            if (res?.status === true) {
                const rawList = res?.data || [];

                const flatList = rawList.flatMap(cat => cat.items || []);

                setMachineryList(flatList);
            }
        } catch (error) {
            console.error("Error fetching machinery list:", error);
        }
    };

    const setMachineryFormValues = (data, shipId) => {
        form.setFieldsValue({
            ship_id: shipId || data?.ship_id,
            machinery_name: functionName || data?.machinery_name || data?.machinary_name,
            category: data?.category || data?.machinary_selected_dropdown,
            manufacturer: data?.manufacturer || data?.machinary_make,
            model: data?.model || data?.machinary_model,
            serial_number: data?.serial_number,
            installation_date: data?.installation_date ? dayjs(data.installation_date) : null,
            running_hours: data?.running_hours,
            current_counter_reading: data?.current_counter_reading,
            reading_date: data?.reading_date ? dayjs(data.reading_date) : null,
            remarks: data?.remarks,
        });
    };

    const clearMachineryFormValues = (shipId) => {
        form.resetFields();
        form.setFieldsValue({
            ship_id: shipId,
            machinery_name: functionName,
            installation_date: dayjs(),
        });
    };

    const fetchMachineryDetails = async (activeShipId = shipId) => {
        if (!activeShipId) return;

        setLoader(true);
        try {
            const FORM_DATA = new FormData();
            FORM_DATA.append("code", location.state.functionCode);
            if (editData?.id && String(editData?.ship_id) === String(activeShipId)) {
                FORM_DATA.append("machinery_id", editData.id);
            } else if (machineryid && String(machineryData?.ship_id) === String(activeShipId)) {
                FORM_DATA.append("machinery_id", machineryid);
            }
            FORM_DATA.append("ship_id", activeShipId);
            FORM_DATA.append("company_id", userData?.data?.company?.company_id);
            const res = await post(ApiURL.staff_view_machinery, FORM_DATA);
            if (res?.status === true) {
                const data = res?.response_data ?? res?.data;
                const responseShipId = data?.ship_id;
                const isSelectedShipData =
                    !responseShipId || String(responseShipId) === String(activeShipId);
                const hasDetails = hasData(data) && isSelectedShipData;
                setHasMachineryDetails(hasDetails);

                if (!hasDetails) {
                    setMachineryData(null);
                    setmachineryId("");
                    clearMachineryFormValues(activeShipId);
                    if (activeTab !== "1") {
                        setActiveTab("1");
                        localStorage.setItem("activeTab", "1");
                    }
                    return;
                }

                setMachineryData(data);
                setmachineryId(data?.id)
                setMachineryFormValues(data, activeShipId);
            }
        } catch (error) {
            console.error("Error fetching machinery details:", error);
            if (editData && String(editData.ship_id) === String(activeShipId)) {
                setMachineryData(editData);
                setmachineryId(editData.id);
                setHasMachineryDetails(true);
                setMachineryFormValues(editData, activeShipId);
            } else {
                setMachineryData(null);
                setmachineryId("");
                setHasMachineryDetails(false);
                clearMachineryFormValues(activeShipId);
            }
        } finally {
            setLoader(false);
        }
    };

    const onFinish = async (values) => {
        setLoader(true);

        try {
            const FORM_DATA = new FormData();
            FORM_DATA.append("code", location.state.functionCode);


            const currentMachineryId = machineryid || machineryData?.id || machineryData?.machinery_id;

            if (currentMachineryId) {
                FORM_DATA.append("machinery_id", currentMachineryId);
            }
            FORM_DATA.append("ship_id", shipId);
            FORM_DATA.append("machinery_name", functionName || values.machinery_name);
            FORM_DATA.append("category", values.category);
            FORM_DATA.append("manufacturer", values.manufacturer || "");
            FORM_DATA.append("model", values.model || "");
            FORM_DATA.append("serial_number", values.serial_number || "");
            FORM_DATA.append("installation_date", values.installation_date ? values.installation_date.format("YYYY-MM-DD") : "");
            FORM_DATA.append("running_hours", values.running_hours || "0");
            FORM_DATA.append("current_counter_reading", values.current_counter_reading || "");
            FORM_DATA.append("reading_date", values.reading_date ? values.reading_date.format("YYYY-MM-DD") : "");
            FORM_DATA.append("remarks", values.remarks || "");

            FORM_DATA.append("company_id", userData?.data?.company?.company_id);
            FORM_DATA.append("user_id", userData?.data?.user_id);

            const apiEndpoint = currentMachineryId ? ApiURL.staff_update_machinery : ApiURL.staff_add_machinery;
            const res = await post(apiEndpoint, FORM_DATA);
            if (res?.status === true) {
                SuccessToast("Success", currentMachineryId ? "Machinery updated successfully!" : "Machinery added successfully!");
                const savedMachineryData = res?.data || res?.response_data || machineryData || { id: res?.machinery_id || currentMachineryId, ship_id: shipId || values.ship_id };

                setMachineryData(savedMachineryData);
                setHasMachineryDetails(true);
                setActiveTab("2");
                setmachineryId(res?.machinery_id || savedMachineryData?.id || currentMachineryId)
            } else {
                ErrorToast("Error", res?.message || `Failed to ${currentMachineryId ? 'update' : 'add'} machinery.`);
            }
        } catch (error) {
            console.error("Submission error:", error);
            ErrorToast("Error", "Something went wrong during submission.");
        } finally {
            setLoader(false);
        }
    };

    return (
        <div className="white-container" style={{ padding: "10px" }}>
            <div className="row" style={{ padding: "10px", marginBottom: "10px" }}>
                <div className="col-6">
                    <div className="theme-content-title text-left">
                        <h3 style={{ margin: 0, display: 'flex', alignItems: 'center' }}>
                            {functionName
                                ? functionName
                                : (viewOnly ? "View Machinery" : (editData ? "Edit Machinery" : "Add Machinery"))}
                            {location.state?.functionCode && <span style={{ fontSize: '16px', color: '#555', marginLeft: '10px' }}>- Code: {location.state.functionCode}</span>}
                        </h3>
                    </div>
                </div>
                <div className="col-6" style={{ textAlign: "right" }}>
                    <Button onClick={() => navigate("/machinery-register")}>Back to List</Button>
                </div>
            </div>
            <Tabs activeKey={activeTab}
                onChange={(key) => {
                    setActiveTab(key);
                    localStorage.setItem("activeTab", key);
                }} style={{ marginTop: '10px' }}>
                <Tabs.TabPane tab="Details" key="1">
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        initialValues={{ installation_date: dayjs() }}
                        disabled={viewOnly}
                    >
                        <Card
                            title={<span style={{ fontWeight: 600 }}>Machinery Details</span>}
                            style={{ marginBottom: "20px", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}
                        >
                            <Row gutter={[24, 16]}>
                                <Col xs={24} sm={12} md={8}>
                                    <Form.Item
                                        name="machinery_name"
                                        label="Machinery Name"
                                        rules={[{ required: true, message: "Please enter machinery name" }]}
                                    >
                                        <Input readOnly placeholder="Machinery name" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8}>
                                    <Form.Item
                                        name="category"
                                        label="Category"
                                        rules={[{ required: true, message: "Please select a category" }]}
                                    >
                                        <Select placeholder="Select Category">
                                            <Select.Option value="Engine">Engine</Select.Option>
                                            <Select.Option value="Propulsion">Propulsion</Select.Option>
                                            <Select.Option value="Pump">Pump</Select.Option>
                                            <Select.Option value="Electrical">Electrical</Select.Option>
                                            <Select.Option value="Cooling">Cooling</Select.Option>
                                            <Select.Option value="Separation">Separation</Select.Option>
                                            <Select.Option value="Safety">Safety</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={[24, 16]}>
                                <Col xs={24} sm={12} md={8}>
                                    <Form.Item name="manufacturer" label="Manufacturer">
                                        <Input placeholder="Enter manufacturer" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8}>
                                    <Form.Item name="model" label="Model">
                                        <Input placeholder="Enter model" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8}>
                                    <Form.Item name="serial_number" label="Serial Number">
                                        <Input placeholder="Enter serial number" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={[24, 16]}>
                                <Col xs={24} sm={12} md={8}>
                                    <Form.Item name="installation_date" label="Installation Date">
                                        <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8}>
                                    <Form.Item name="running_hours" label="Initial Running Hours">
                                        <Input type="number" placeholder="Enter running hours" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8}>
                                    <Form.Item name="current_counter_reading" label="Current Counter Reading">
                                        <Input type="number" placeholder="Enter current reading" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={[24, 16]}>
                                <Col xs={24} sm={12} md={8}>
                                    <Form.Item name="reading_date" label="Reading Date">
                                        <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={24}>
                                <Col span={24}>
                                    <Form.Item name="remarks" label="Remarks">
                                        <TextArea rows={3} placeholder="Enter remarks here..." />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Card>

                        {!viewOnly && (
                            <div style={{ textAlign: "center", marginTop: "40px", marginBottom: "30px" }}>
                                <Button
                                    type="primary"
                                    size="large"
                                    htmlType="submit"
                                    loading={loader}
                                    className="save_btn"
                                    style={{
                                        height: "48px",
                                        padding: "0 80px",
                                        borderRadius: "24px",
                                        fontWeight: 600,
                                        fontSize: "16px",
                                    }}
                                >
                                    {editData ? "Update Machinery" : "Save Machinery"}
                                </Button>
                            </div>
                        )}
                    </Form>
                </Tabs.TabPane>
                <Tabs.TabPane
                    tab="Job Register"
                    key="2"
                    disabled={
                        !hasMachineryDetails ||
                        (
                            !machineryData &&
                            !form.getFieldValue("ship_id") &&
                            !form.getFieldValue("machinery_name") &&
                            !form.getFieldValue("category")
                        )
                    }
                >
                    <JobRegisterTab
                        key={`jobs-${shipId || "no-ship"}-${machineryid || "no-machinery"}`}
                        code={location.state.functionCode}
                        machineryid={machineryid}
                        machineryData={machineryData}
                        functionCode={location.state?.functionCode}
                        shipId={shipId}
                    />
                </Tabs.TabPane>
                <Tabs.TabPane
                    tab="Work Order"
                    key="3"
                    disabled={
                        !hasMachineryDetails ||
                        (
                            !machineryData &&
                            !form.getFieldValue("ship_id") &&
                            !form.getFieldValue("machinery_name") &&
                            !form.getFieldValue("category")
                        )
                    }
                >
                    <WorkOrderTab
                        key={`work-orders-${shipId || "no-ship"}-${machineryid || "no-machinery"}`}
                        code={location.state.functionCode}
                        machineryid={machineryid}
                        machineryData={machineryData}
                        functionCode={location.state?.functionCode}
                        shipId={shipId}
                    />
                </Tabs.TabPane>
                <Tabs.TabPane
                    tab="History"
                    key="4"
                    disabled={
                        !hasMachineryDetails ||
                        (
                            !machineryData &&
                            !form.getFieldValue("ship_id") &&
                            !form.getFieldValue("machinery_name") &&
                            !form.getFieldValue("category")
                        )
                    }
                >
                    <WorkHistoryTab
                        code={location.state.functionCode}
                        machineryid={machineryid}
                        machineryData={machineryData}
                        functionCode={location.state?.functionCode}
                        shipId={shipId}
                    />
                </Tabs.TabPane>
            </Tabs>
        </div>
    );
};

export default AddMachinery;
